// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import DatePicker from 'react-datepicker';

// Core Libs
import {formatDate, formatTimezone, parseDate} from '../../lib/core/date';

// Components
import PortalContainer from './portal-container';

// Containers
import withFormField from '../../containers/with-form-field';

// Styles
import './date-time.scss';

function DateTime({
  disableAutofill,
  formIsSearch,
  id,
  onChange,
  parseFormat,
  showDate = true,
  showTime = false,
  showTimeSeconds = false,
  showTimezone = false,
  value,
}) {
  const getClass = () => classnames(
      {
        'date-time_search': formIsSearch,
      },
      'date-time'
        );

  const getDateFormat = () => (showTime ? `MM/dd/yyyy ${getTimeFormat()}` : 'MM/dd/yyyy');

  function getDateTimeProps() {
    const data = {
      className: 'date-time--date',
      name: disableAutofill ? undefined : name,
      id,
      onChange: handleChange,
      onChangeRaw: handleChange,
      selected: parseDate(value, parseFormat),
      dateFormat: getDateFormat() || '',
      disabledKeyboardNavigation: true,
      popperContainer: PortalContainer,
      ...getTimeProps(),
    };
    return data;
  }

  const getTimeClass = () => classnames(
      {
        'date-time--time-seconds': showTimeSeconds,
      },
      'date-time--time'
        );

  const getTimeFormat = () => (showTimeSeconds ? 'hh:mm:ss' : 'hh:mm');

  const getTimeProps = () => (showTime
            ? {
                  className: getTimeClass(),
                  showTimeSelect: true,
                  timeFormat: getTimeFormat(),
                  timeIntervals: 15,
                  timeCaption: 'Time',
                  dateFormat: getDateFormat(),
              }
            : null);

  const getTimezoneProps = () => ({
    className: 'date-time--timezone',
    children: formatTimezone(value, 'z') || '',
    title: formatTimezone(value, undefined, 'UTC'),
  });

  const handleChange = (event) => {
    if (event && event.getDay) {
      onChange(event, formatDate(event, showTime ? 'YYYY-MM-DDTHH:mm:ssZ' : 'YYYY-MM-DD'));
    } else {
      // Only allow clearing if there's no current value
      // This prevents the date from disappearing when the same date is clicked twice
      const currentDate = parseDate(value, parseFormat);
      if (!currentDate || !value || !event) {
        onChange(event, null);
      }
      // If there's already a date selected, ignore the null event (double-click behavior)
    }
  };

  const renderDateTime = () => (showDate ? <DatePicker {...getDateTimeProps()} /> : null);

  const renderTimezone = () => (showTimezone ? <span {...getTimezoneProps()} /> : null);

  return (
        <div className={getClass()}>
            {renderDateTime()}
            {renderTimezone()}
        </div>
  );
}

DateTime.propTypes = {
    disableAutofill: PropTypes.bool,
    formIsSearch: PropTypes.bool,
    id: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    parseFormat: PropTypes.string.isRequired,
    showDate: PropTypes.bool,
    showTime: PropTypes.bool,
    showTimeSeconds: PropTypes.bool,
    showTimezone: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default withFormField(DateTime);
